import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SelectField, FilesDropzone } from 'components';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { Grid, Button, Autocomplete, TextField, createFilterOptions } from '@mui/material';
import { enqueueSnackbar } from 'actions';

import { SetFormState, NbrRelationsValidationUploadRun } from '../../actions/NbrRelationsValidationActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const NbrRelationsValidationForm = (props) => {
	const { sites, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const user = useSelector(state => state.session.user);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.nbrRelationsValidationReducer.formState);

	const filterOptions = createFilterOptions({
		limit: 50
	});

	const _NbrRelationsFilesUpload = files => {
		files.forEach(file => {
			if (!file.size > 10000000) {
				dispatch(
					enqueueSnackbar({
						message: `File ${file.name} not valid. Please check file size.`,
						options: { variant: 'warning' }
					})
				);
			}
		});
		dispatch(NbrRelationsValidationUploadRun(formState.siteId, user.id, files));
	};

	const _handleChange = (name, value) => {
		setFormState({
			...formState,
			[name]: value,
		});
	};

	return (
		<div className={classes.fields}>
			<Grid container spacing={2}>
				<Grid item md={4} xs={4}>
					<Autocomplete
						id="siteId"
						name="siteId"
						hintText="Site Id"
						options={sites || []}
						value={{ value: formState.siteId || '', text: formState.siteId || '' }}
						getOptionLabel={(option) => `${option.text}`}
						renderInput={(params) => <TextField {...params} label="Site ID" variant="outlined" />}
						filterOptions={filterOptions}
						onChange={(event, value) => { _handleChange('siteId', value.value); }}
					/>
				</Grid>
				<Grid item md={8} xs={8}>
					<FilesDropzone acceptedTypes=".xlsx" upload={_NbrRelationsFilesUpload} />
				</Grid>
			</Grid>
		</div>
	);
};

NbrRelationsValidationForm.propTypes = {
	sites: PropTypes.array.isRequired
};

export default NbrRelationsValidationForm;
